import { ChangeEvent, useCallback, useEffect, useState } from 'react';

interface ITextAreaProps {
	id: string | undefined;
	name: string;
	value: any;
	onChange?: null | ((name: string, value: any) => void);
	className?: string;
	required?: boolean;
	disabled?: boolean;
	showCounter?: boolean;
	maxLength?: null | number;
	rows?: null | number;
	placeholder?: string;
	dataCy?: string;
}

export const TextArea = ({
	id,
	name,
	value,
	onChange = null,
	className = '',
	required = false,
	disabled = false,
	showCounter = false,
	maxLength = null,
	rows = null,
	placeholder = '',
	dataCy = ''
}: ITextAreaProps) => {
	const [val, setVal] = useState<string>(value);

	const onChangeInternal = useCallback(
		(e: ChangeEvent<HTMLTextAreaElement>) => {
			setVal(e.target.value);
			if (onChange) {
				onChange(e.target.name, e.target.value);
			}
		},
		[setVal, onChange]
	);

	useEffect(() => {
		if (value !== val) {
			setVal(value);
		}
	}, [value, val]);

	return (
		<div className="position-relative mb-3">
			<textarea
				id={id}
				value={val}
				onChange={onChangeInternal}
				className={className + (showCounter ? ' pb-4' : '')}
				required={required}
				disabled={disabled}
				placeholder={placeholder}
				rows={rows ? rows : undefined}
				name={name}
				data-cy={dataCy}
				maxLength={maxLength ? maxLength : undefined}
			/>
			{showCounter ? (
				<div className="textarea-counter">
					{val.length}
					{maxLength ? ' / ' + maxLength : ''}
				</div>
			) : null}
		</div>
	);
};
